import React, { memo } from "react"
import BreadCrumb from "components/BreadCrumb"
import { StyledAppBar } from "./style"
import routes from "../../routes"

function AppUtilityBar() {
  return (
    <StyledAppBar color="primary" position="sticky" elevation={0}>
      <BreadCrumb routes={routes} />
    </StyledAppBar>
  )
}
export default memo(AppUtilityBar)
